import { Outlet, createBrowserRouter, Navigate } from "react-router-dom";
import SignIn from "./pages/sign-in";
import { RoutePath } from "./constants";
import BookManagement from "./pages/admin/book-management";
import AdminLayout from "./layout/admin-layout";
import CreateBook from "./pages/admin/create-book";
import UpdateBook from "./pages/admin/update-book";
import { isAuthenticated } from "./loaders/authentication";
import DeleteAccountPage from "./pages/google-console";
import VoiceTrainManagement from "./pages/admin/voice-train-management";
import AccountInfo from "./pages/admin/account-info";
import WalletManagement from "./pages/admin/wallet-management";
import WithdrawHistoryManagement from "./pages/admin/withdraw-history-management";
import StatisticsManagement from "./pages/admin/statistics";
import FAQManagement from "./pages/admin/faq-management";

const router = createBrowserRouter([
  {
    path: RoutePath.HOME,
    element: <AdminLayout />,
    loader: isAuthenticated,
    children: [
      {
        index: true,
        element: <Navigate to={RoutePath.STATISTICS} replace />,
      },
      {
        path: RoutePath.STATISTICS,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <StatisticsManagement />,
          },
        ],
      },
      {
        path: RoutePath.BOOK_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <BookManagement />,
          },
          {
            path: RoutePath.CREATE_BOOK,
            element: <CreateBook />,
          },
          {
            path: RoutePath.UPDATE_BOOK_ID,
            element: <UpdateBook />,
          },
        ],
      },
      // {
      //   path: RoutePath.BANK_MANAGEMENT,
      //   element: <BankManagement />,
      // },
      {
        path: RoutePath.VOICE_TRAIN_MANAGEMENT,
        element: <VoiceTrainManagement />,
      },
      {
        path: RoutePath.ACCOUNT_INFO,
        element: <AccountInfo />,
      },
      {
        path: RoutePath.WALLET_MANAGEMENT,
        element: <WalletManagement />,
      },
      {
        path: RoutePath.WITHDRAW_MANAGEMENT,
        element: <WithdrawHistoryManagement />,
      },
      {
        path: RoutePath.FAQ_MANAGEMENT,
        element: <FAQManagement />,
      },
    ],
  },
  {
    path: RoutePath.SIGN_IN,
    element: <SignIn />,
    loader: isAuthenticated,
  },
  {
    path: RoutePath.GOOGLE_CONSOLE,
    children: [
      {
        path: "delete",
        element: <DeleteAccountPage />,
      },
    ],
  },
  {
    path: "*",
    element: <div>404 Not Found</div>,
  },
]);

export default router;
